import { Skeleton, Table, TableProps } from "antd";
import React from "react";
import { FaEdit, FaEye, FaTrashAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useOrganizationData } from "../../../../services/api/settings";
import { Admin } from "../../../../store/types/settings";
import { useAdmins } from "../../misc/useAdminRegister";

const AdminMain: React.FC = () => {
  const navigate = useNavigate();
  const { organizationData } = useOrganizationData();
  const { data, loading } = useAdmins(organizationData?.id || "");
  const adminsData = data?.admins || [];

  const columns: TableProps<Admin>["columns"] = [
    {
      title: "S/N",
      dataIndex: "key",
      width: 60,
      align: "center",
      render: (_, __, index) => index + 1,
    },
    // {
    //   title: "Admin Name",
    //   dataIndex: "firstName",
    //   render: (_, record) => (
    //     <div className="font-medium">
    //       {record?.firstName} {record?.lastName}
    //     </div>
    //   ),
    // },
    {
      title: "Email",
      dataIndex: "email",
      render: (_, record) => <div>{record?.email}</div>,
    },
    {
      title: "Role",
      dataIndex: "role",
      render: (_, record) => (
        <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
          {record?.role
            ?.replace(/_+/g, " ")
            .toLowerCase()
            ?.replace(/\b\w/g, (char) => char.toUpperCase())}
        </span>
      ),
    },
    {
      title: "Plan",
      dataIndex: "subscriptionTier",
      render: (_, record) => (
        <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-sm">
          {record?.organization?.subscriptionTier
            ?.replace(/_+/g, " ")
            .toLowerCase()
            ?.replace(/\b\w/g, (char) => char.toUpperCase())}
        </span>
      ),
    },
    // {
    //   title: "Last Login",
    //   dataIndex: "lastLoginAt",
    //   render: (date) => {
    //     if (!date) return <span className="text-gray-400">Never</span>;
    //     return new Date(date).toLocaleDateString();
    //   },
    // },
    {
      title: "Date Created",
      dataIndex: "createdAt",
      render: (date) => new Date(date).toLocaleDateString(),
    },
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   width: 120,
    //   align: "center",
    //   render: (_, record) => (
    //     <div className="flex items-center justify-center gap-3">
    //       <Link
    //         to={`/admin/${record?.id}`}
    //         className="cursor-pointer text-blue-600 hover:text-blue-800"
    //       >
    //         <FaEye />
    //       </Link>
    //       <Link
    //         to={`/edit-admin/${record?.id}`}
    //         className="cursor-pointer text-green-600 hover:text-green-800"
    //       >
    //         <FaEdit />
    //       </Link>
    //       <div
    //         onClick={() => {
    //           console.log("Delete admin clicked for:", record);
    //         }}
    //         className="cursor-pointer text-red-600 hover:text-red-800"
    //       >
    //         <FaTrashAlt />
    //       </div>
    //     </div>
    //   ),
    // },
  ];
  return (
    <div className="w-full py-5">
      <div className="max-w-[1096px] mx-auto px-3">
        <div className="flex border-b border-border text-20 pt-3">
          <div
            onClick={() => navigate(`/settings/profile`)}
            className="pb-1 cursor-pointer md:mr-8 mr-5"
          >
            <p className="font-[400]">Profile</p>
          </div>
          <div
            onClick={() => navigate(`/settings/admin/create`)}
            className={`pb-1 cursor-pointer md:mr-8 mr-5`}
          >
            <p className="font-[400]">Create Admin</p>
          </div>
          <div
            onClick={() => navigate(`/settings/admin`)}
            className="border-b-[3px] border-secondary pb-1 cursor-pointer md:mr-8 mr-5"
          >
            <p className="font-[400]">Admins</p>
          </div>
          <div
            onClick={() => navigate(`/settings/change-password`)}
            className="pb-1 cursor-pointer"
          >
            <p className="font-[400]">Change Password</p>
          </div>
        </div>
        <div className="rounded-10 bg-white px-4 py-5 mt-5">
          {loading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : organizationData ? (
            <div>
              <div className="mb-4">
                <h3 className="text-lg font-semibold">
                  Admins ({adminsData.length})
                </h3>
                <p className="text-sm text-gray-600">
                  Manage administrators across all organizations
                </p>
              </div>
              <Table
                dataSource={adminsData}
                columns={columns}
                loading={loading}
                rowKey="id"
                pagination={{
                  pageSize: 10,
                  showSizeChanger: true,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} admins`,
                  total: data?.total,
                }}
                // scroll={{ x: 1000 }}
              />
            </div>
          ) : (
            <div className="text-center text-gray-500 py-8">
              <p>No admin data available.</p>
              <p className="text-sm">
                Please check your data source and try again.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminMain;
